/* eslint-disable react/prop-types -- project uses JSX without PropTypes package */
import { TABLE_MEASUREMENTS } from "../../types/types";

export default function MeasurementUnitToggle({
  value,
  onChange,
  disabled = false,
  className = "",
}) {
  return (
    <div
      className={`inline-grid grid-cols-2 bg-white-smoke p-1.5 rounded-av ${className}`}
      role="group"
      aria-label="Measurement unit"
    >
      <button
        type="button"
        disabled={disabled}
        className={`px-4 py-2 text-sm font-medium rounded-av transition-colors ${
          value === TABLE_MEASUREMENTS.INCHES
            ? "bg-primary text-white shadow-sm"
            : "text-slate-600 hover:text-slate-900"
        }`}
        onClick={() => onChange(TABLE_MEASUREMENTS.INCHES)}
      >
        in
      </button>
      <button
        type="button"
        disabled={disabled}
        className={`px-4 py-2 text-sm font-medium rounded-av transition-colors ${
          value === TABLE_MEASUREMENTS.CM
            ? "bg-primary text-white shadow-sm"
            : "text-slate-600 hover:text-slate-900"
        }`}
        onClick={() => onChange(TABLE_MEASUREMENTS.CM)}
      >
        cm
      </button>
    </div>
  );
}
